<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-5 col-md-12 mb-4">
                      <h2>Holdings</h2>
                      <div class="ims-tab ml-0">
                        <router-link to="/bidaccumulator/trader" class="inv-btn" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baTraderAllHoldings' }" >
                              All Holdings
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/trader/operatorsent">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorSent' }" >
                            Operator Sent
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/trader/bidwanted" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baTraderBidwanted' }" >
                            Bid Wanted
                          </button>
                        </router-link>
                      </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div> 
        
</template>
<script>

export default {
  name: "baholdings",
  components : {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {


  }
};
</script>